import { Copy06 } from '@untitled-ui/icons-react/build/cjs';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import TooltipCmp from 'src/components/TooltipCmp';
import TruncateTextCmp from 'src/components/TruncateText';
import { copyToClipboard } from 'src/utils/CommonFunctions';
import WalToast from 'src/utils/WalToast';

interface IAddressTooltipContentProps {
    /** Shipper / consignee company name, shown bold above the address. */
    shipperConsigneeName?: string;
    fullAddress?: string;
    canCopyAddress?: boolean;
}

/** Address card for CellDropdown: name, full address, optional copy button. Port of WALHQ's V3DropdownCmp/AddressTooltipContent. */
const AddressTooltipContent = ({ shipperConsigneeName, fullAddress, canCopyAddress }: IAddressTooltipContentProps) => {
    const { t } = useTranslation();
    const nameRef = useRef<HTMLHeadingElement>(null);
    const addressRef = useRef<HTMLParagraphElement>(null);

    return (
        <>
            {shipperConsigneeName && (
                <TruncateTextCmp refName={nameRef} message={shipperConsigneeName}>
                    <h6 ref={nameRef} className="text-grayLight900 text-xs leading-[1.5] font-medium truncate">
                        {shipperConsigneeName}
                    </h6>
                </TruncateTextCmp>
            )}
            <div className="flex justify-between gap-x-2 min-w-0">
                <TruncateTextCmp refName={addressRef} message={fullAddress || '-'}>
                    <p ref={addressRef} className="text-xs leading-[1.5] font-medium text-gray500 line-clamp-2">
                        {fullAddress || '-'}
                    </p>
                </TruncateTextCmp>
                {canCopyAddress && fullAddress && (
                    <TooltipCmp TooltipCustomClass="tooltipV3-content-wrap" message={t('Common.Copy')}>
                        <Copy06
                            className="w-4 h-4 text-primary cursor-pointer flex-none"
                            onClick={(e: React.MouseEvent) => {
                                e.stopPropagation();
                                copyToClipboard(fullAddress);
                                WalToast.copy(t('Common.Copied_to_clipboard'), '', 'copy-msg');
                            }}
                        />
                    </TooltipCmp>
                )}
            </div>
        </>
    );
};

export default AddressTooltipContent;
